var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTulu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2063",
    transform: "translate(127 1079)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h75v75H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "24/7 costumer support",
    transform: "translate(-127 -1079)",
    style: {
      clipPath: "url(#a)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4210",
    d: "M169.218 1121.679a18.964 18.964 0 0 0 13.211-11.9c5.137-.131 5.817-6.615 4.7-9.98a4.151 4.151 0 0 0-3.2-2.875 22.344 22.344 0 0 0-2.6-7.717c-2.336-4.113-7.163-8.981-16.931-8.85s-14.437 4.927-16.645 8.921a20.631 20.631 0 0 0-2.383 7.614 4.174 4.174 0 0 0-3.363 2.908c-1.138 3.413-.421 10.033 4.917 9.981a18.964 18.964 0 0 0 13.21 11.9 23.583 23.583 0 0 0-23.126 23.55 8.576 8.576 0 0 0 8.566 8.566h38.211a8.576 8.576 0 0 0 8.566-8.566 23.584 23.584 0 0 0-23.133-23.552zm3.914 2.078-3.265 4.963-3.687-5.4h2.6a21.925 21.925 0 0 1 4.352.437zm-26.67-26.96a19.678 19.678 0 0 1 2.227-7c3.012-5.446 8.3-8.26 15.716-8.364 7.387-.108 12.766 2.678 15.957 8.27a21.383 21.383 0 0 1 2.443 7.089c-.172 0-.312 0-.415.01a18.919 18.919 0 0 0-17.719-12.347 18.912 18.912 0 0 0-17.712 12.351c-.165-.002-.36-.008-.497-.009zm2.559 13.745a20.916 20.916 0 0 0 10.235 4.865 2.464 2.464 0 0 0 2.567 1.974 2.414 2.414 0 0 0 2.581-2.2 2.414 2.414 0 0 0-2.581-2.2 2.614 2.614 0 0 0-2.386 1.364 19.82 19.82 0 0 1-11.3-6.172 17.109 17.109 0 0 1-.573-2.8c5.466-2.65 4.535-9.2 4.535-9.2 12.689 5.7 25.219.346 25.219.346a11.323 11.323 0 0 0 4.515 8.391 17.254 17.254 0 0 1-17.159 15.667 17.248 17.248 0 0 1-15.653-10.036zm11.54 12.781h2.428l-3.687 5.4-3.243-4.93a21.9 21.9 0 0 1 4.501-.471zm23.217 28.818h-38.211a6.92 6.92 0 0 1-6.912-6.912 21.941 21.941 0 0 1 15.924-21.07l4.7 7.145 5.306-7.768 5.305 7.768 4.728-7.186a21.941 21.941 0 0 1 16.072 21.111 6.92 6.92 0 0 1-6.912 6.912z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTulu1);
export default __webpack_public_path__ + "static/media/myTulu1.8f82c548265a51eafc3b5a8ea213878b.svg";
export { ForwardRef as ReactComponent };